import Cookies, { CookieSetOptions } from "universal-cookie";
import URI from "urijs";
import { cookies, endpoints } from "config";

const expiryInSeconds = 7 * 24 * 60 * 60;
const cookie = new Cookies();

const cookieOptions: CookieSetOptions = {
  path: "/",
  // guard: at build time (SSR page-data collection) there is no window; an
  // unset NEXT_PUBLIC_WEB_ROOT must degrade instead of crashing the build
  domain: URI(
    endpoints.web ||
      (typeof window === "undefined" ? "" : window.location.host)
  ).domain(),
  secure: cookies.secureCookie,
  maxAge: expiryInSeconds,
};

export const getZipCodeFromCookie = (): string | undefined => {
  return cookie.get(cookies.zipCode) || undefined;
};

export const setZipCodeCookie = (zip: string): void => {
  cookie.remove(cookies.zipCode);
  cookie.set(cookies.zipCode, zip, cookieOptions);
};
